import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomSelectComponent} from './custom-select.component';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";


@NgModule({
    declarations: [
        CustomSelectComponent
    ],
    exports: [
        CustomSelectComponent,
        FormsModule,
        ReactiveFormsModule
    ],
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule
    ]
})
export class CustomSelectModule { }
